<template>
  <!-- Nav -->
  <nav class="nav theme--dark">
    <div class="nav__wrapper">
      <div class="nav__wrapper--left">
        <a title="menu" class="mobile-menu" @click="toggleMenu">
          <i aria-hidden="true" class="icon icon-menu5"></i>
        </a>
        <div v-if="mobileMenu">
          <ul class="float--left desktop-menu" v-if="isActive">
            <li v-for="(menu, index) in menus" :key="index">
              <router-link :to="menu.link" :router-link="menu.link" rel="noopener" @click.native="toggleMenu">
                {{ $t(menu.item) }}
              </router-link>
            </li>
          </ul>
        </div>
        <div v-if="!mobileMenu">
          <ul class="float--left desktop-menu">
            <li v-for="(menu, index) in menus" :key="index">
              <router-link :to="menu.link" :router-link="menu.link" rel="noopener">
                {{ $t(menu.item) }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="nav__wrapper--right">
        <LocaleSwitcher class="locale-switcher float--right"></LocaleSwitcher>
        <ul class="float--right">
          <li v-for="(icon, index) in socialLinks" :key="index">
            <a :href="icon.link" :title="icon.title" target="_blank" rel="noopener">
              <i aria-hidden="true" class="icon" :class="`icon-${icon.icon}`"></i>
            </a>
          </li>
        </ul>
        
      </div>
    </div>
  </nav>
</template>

<script>
import { constants } from "@/lib/constants";
import { isSmallScreen } from "@/lib/utilities";
import LocaleSwitcher from "@/components/common/LocaleSwitcher";

export default {
  name: "Nav",
  data() {
    return {
      menus: constants.menus,
      socialLinks: constants.socialLinks,
      isActive: false,
      windowWidth: window.innerWidth,
      mobileMenu: false
    };
  },
  components: {
    LocaleSwitcher
  },
  computed: {
    // It will return true if user is using mobile device [It calculate using display width]
    smallScreen() {
      return isSmallScreen(this.windowWidth);
    }
  },
  created() {
    if (this.smallScreen) {
      this.mobileMenu = true;
    }
  },
  mounted() {
    window.addEventListener(
      "orientationchange",
      this.handleOrientationChange
    );
  },
  methods: {
    toggleMenu() {
      this.isActive = !this.isActive;
    },
    handleOrientationChange() {
      const orientation = window.screen.orientation.type
      const iPadScreen = window.screen.width >= 768;
      if (orientation === "portrait-primary" && !iPadScreen) {
        this.mobileMenu = true;
      } else if (orientation === "landscape-primary") {
        // landscape mode
        this.mobileMenu = false;
      }
    }
  }
};
</script>
